import { Identifiable, List, Project, RankedElement } from "@planzone/dto";
import React from "react";

enum ElementTypes {
  TASK = "task",
  LIST = "list",
  MILESTONE = "milestone",
  EVENT = "event",
}

interface Props {
  project: Identifiable<Project>;
  parentList?: Identifiable<List>;
  range?: {
    min: RankedElement<any> | null;
    max: RankedElement<any> | null;
  };
  defaultType?: ElementTypes;
  done?(): void;
  loader?(type: ElementTypes, name: string): React.ReactNode;
}

export type { Props };

export { ElementTypes };
